import React from 'react';
import clsx from 'clsx';

import Section from '@common/Section';
import Container from '@common/Container';
import Heading from '@common/Heading';
import Row from '@common/Row';
import ColouredTextBlock from '@common/ColouredTextBlock';

const ColouredTextBlocks = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(title && showTitle) && <Heading type='h2'>{title}</Heading>}
        <Row className='ps-1 row-cols-md-2 row-cols-xl-4 g-3 list-title-border'>  
          {list && list.map((card, index) => (
            <ColouredTextBlock key={index} data={card}/>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default ColouredTextBlocks
